const publicPath='czbv' // 项目名称
const appid='wxe985389fee3bbe76' // appid
const link="https://h5.zddxdd.com/czbi/" // 主路径名
const getAvatar=false //获取头像
module.exports = {
    publicPath:publicPath,
    openIdName:`${publicPath}Openid`,
    userInfoName:`${publicPath}UserInfo`,
    
    title:"格力舒享家", // 项目标题
    link,
    shareConfig:{
        open:true,    // 是否开启分享
        shareBaseUrl:'https://api.h5.zddxdd.com/',
        option: {   // 分享参数
            title: '格力舒享家 智慧生活，一步到位',
            link,
            desc: '格力舒享家 智慧生活，一步到位',
            imgUrl: 'https://h5.dotnet-pr.com/czbi/share.jpg'
        }
    },
    authConfig:{    // 授权配置
        open:false,// 开启授权
        appid:appid,
        authorizationLink:'https://open.weixin.qq.com/connect/oauth2/authorize?appid='+appid+'&redirect_uri=' + link + '&response_type=code&scope='+(getAvatar?'snsapi_userinfo':'snsapi_base')+'&state=1#wechat_redirect',
    },
    backgroundMusic:{
        open:false, //是否开启背景音乐
        url:'http://zddxdd-h5.oss-cn-shanghai.aliyuncs.com/demo/bgm.mp3' //音乐路径
    }
}